import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class DataSharing {
    public JobSiteDataChangeEvent=new EventEmitter();
    public DropDownChangeEvent=new EventEmitter();
    jobsiteDataChanged(data:any){
        this.JobSiteDataChangeEvent.emit(data)
    }
    dropDownChangeEvent(data:any){
        this.DropDownChangeEvent.emit(data)
    }
}